import photo_1 from "./Area51Pictures/Photo-1.jpg";
import photo_2 from "./Area51Pictures/Photo-2.webp";
import photo_3 from "./Area51Pictures/Photo-3.webp";
import photo_4 from "./Area51Pictures/Photo-4.webp";
import photo_5 from "./Area51Pictures/Photo-5.webp";
import photo_6 from "./Area51Pictures/Photo-6.webp";
import photo_7 from "./Area51Pictures/Photo-7.webp";
import photo_8 from "./Area51Pictures/Photo-8.webp";
import photo_9 from "./Area51Pictures/Photo-9.webp";
import photo_10 from "./Area51Pictures/Photo-10.webp";

export const Area51PhotoContent = [
  {
    id: 1,
    title: "Album",
    latestPicture: {
      image: photo_2,
      date: "13 Sep 2024",
      time: "8:03am",
      location: "",
    },
    pictures: [
      {
        image: photo_2,
        date: "13 Sep 2024",
        time: "8:03am",
        location: "",
      },
      {
        image: photo_9,
        date: "15 Aug 2024",
        time: "2:47pm",
        location: "",
      },
      {
        image: photo_4,
        date: "3 Jun 2024",
        time: "11:31am",
        location: "",
      },
      {
        image: photo_5,
        date: "3 Jun 2024",
        time: "11:38am",
        location: "",
      },
      {
        image: photo_6,
        date: "3 Jun 2024",
        time: "12:06pm",
        location: "",
      },
      {
        image: photo_7,
        date: "3 Jun 2024",
        time: "12:21pm",
        location: "",
      },
      {
        image: photo_1,
        date: "4 May 2024",
        time: "Screenshot",
        location: "",
      },
      {
        image: photo_10,
        date: "21 Apr 2024",
        time: "3:11pm",
        location: "",
      },
      {
        image: photo_3,
        date: "9 Apr 2024",
        time: "9:15am",
        location: "",
      },
      {
        image: photo_8,
        date: "21 Mar 2024",
        time: "12:33",
        location: "",
      },
    ],
  },
];
